<template>
  <section class="page black ">
    <b-container class="story bg-black ">
      <b-row>
        <div class="date-filter ">
          <p>
            Zeige mir Änderungen im Zeitraum vom <br class="mobile-break" />
            <input type="date" v-model="start" /><br class="mobile-break" />
            bis zum<br class="mobile-break" />
            <input type="date" v-model="end" />
          </p>
          <p>
            <span @click="lastWeek()" class="pill">letzte Woche</span>
            <span @click="lastMonth" class="pill">letzter Monat</span
            ><br class="mobile-break" />
            <span @click="sinceStart()" class="pill">seit Beginn</span>
          </p>
        </div>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "DateRangeChooser",
  props: ["startDate", "endDate"],

  data() {
    return {
      start: this.$props.startDate,
      end: this.$props.endDate
    };
  },

  methods: {
    lastWeek() {
      let beforeOneWeek = new Date(
          new Date().getTime() - 60 * 60 * 24 * 7 * 1000
        ),
        day = beforeOneWeek.getDay(),
        diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
        lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
        lastSunday = new Date(beforeOneWeek.setDate(diffToMonday + 6));
      this.start = lastMonday.toISOString().split("T")[0];
      this.end = lastSunday.toISOString().split("T")[0];
      this.emitUpdate();
    },

    lastMonth() {
      let firstDay = new Date();
      firstDay.setDate(0);
      firstDay.setDate(1);
      let lastDay = new Date();
      lastDay.setDate(0);
      this.start = firstDay.toISOString().split("T")[0];
      this.end = lastDay.toISOString().split("T")[0];
      this.emitUpdate();
    },

    sinceStart() {
      this.start = "2021-01-01";
      this.end = new Date().toISOString().split("T")[0];
      this.emitUpdate();
    },

    emitUpdate() {
      this.$emit("updateDate", { startDate: this.start, endDate: this.end });
    }
  },

  watch: {
    start() {
      this.emitUpdate();
    },
    end() {
      this.emitUpdate();
    }
  }
};
</script>

<style scoped lang="scss">
.scrolling-list {
  max-height: 600px;
  overflow-y: scroll;
  padding-bottom: 30px;
}

.scrolling-list::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.scrolling-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #111111;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.9);
}

.vbt-autcomplete-list {
  border-radius: 0px;

  .list-group-item:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
  .list-group-item:last-child {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}
.interactive-title {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  font-style: italic;
}

.black {
  background-color: #111;
  color: #fff;
  padding-top: 3vh;
  padding-bottom: 3vh;
}

.list-group-flush > .list-group-item {
  padding-left: 0;
}

.date-filter {
  margin: 0 auto;
  text-align: center;
}
.pill {
  border: 2px solid #fff;
  border-radius: 30px;
  padding: 10px;
  margin: 12px;
  line-height: 80px;
  cursor: pointer;
  white-space: nowrap;
}

.pill:hover {
  border: 2px solid #fff;
  background-color: #fff;
  color: #111;
  cursor: pointer;
}
.bg-black {
  background-color: #111;
}

.rotate {
  animation: rotation 8s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
@media screen and (min-width: 600px) {
  .mobile-break {
    display: none;
  }
}
</style>
